// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"e9dc179d97763a09","4661":"768bc501da0857bd"}[chunkId] + ".css";
};